import update from "immutability-helper";
import groupBy from "lodash/groupBy";
import * as actionTypes from "../../constants/actionTypes";

const initialState = {
  isLoading: false,
  isFinished: false,
  isError: false,
  error: null,
  results: [],
  data: {
    profileInfo: {
      first_name: "",
      last_name: "",
      email: "",
      job_title: "",
      industry: "",
      subscriptionIds: [],
      savedStoryIds: [],
      saved_stories: [],
      linkedin: "",
      facebook: "",
      twitter: "",
    },
    subscriptions: [],
  },
};

export default (state = initialState, action) => {
  switch (action.type) {
    case (actionTypes.GET_USER_DATA): {
      return Object.assign({}, state, {
        isLoading: true,
        isFinished: false,
        isError: false,
        error: null,
      });
    }

    case (actionTypes.GET_USER_DATA_SUCCESS): {
      // Pull out subscription IDs from array of objects
      const subscriptionIds = action.payload.subscriptions.map((subscription) => {
        return subscription.id;
      });

      // Pull out saved story IDs from array of objects
      const savedStoryIds = action.payload.saved_stories.map((saved_story) => {
        return saved_story.id;
      });

      const payloadWithDetails = Object.assign({}, action.payload, {
        display_name: `${action.payload.first_name} ${action.payload.last_name}`,
        subscriptionIds: subscriptionIds,
        savedStoryIds: savedStoryIds,
        isLoading: false,
        isFinished: true,
      });

      return update(state, {
        data: {
          $merge: {
            profileInfo: payloadWithDetails,
          },
        },
      });
    }

    case (actionTypes.GET_USER_DATA_ERROR): {
      return Object.assign({}, state, {
        isLoading: false,
        isFinished: true,
        isError: true,
        error: action.payload,
      });
    }

    case (actionTypes.TYPING_USER_SETTINGS): {
      return update(state, {
        data: {
          profileInfo: {
            $merge: action.payload,
          },
        },
      });
    }

    case (actionTypes.SUBMIT_USER_SETTINGS): {
      return Object.assign({}, state, {
        isLoading: true,
        isFinished: false,
        isError: false,
        error: null,
      });
    }

    case (actionTypes.SUBMIT_USER_SETTINGS_SUCCESS): {
      let newState = Object.assign({}, state, {
        isLoading: false,
        isFinished: true,
      });

      return update(newState, {
        data: {
          profileInfo: {
            $merge: {
              display_name: `${action.payload.first_name} ${action.payload.last_name}`,
            },
          },
        },
      });
    }

    case (actionTypes.SUBMIT_USER_SETTINGS_ERROR): {
      return Object.assign({}, state, {
        isLoading: false,
        isFinished: true,
        isError: true,
        error: action.payload,
      });
    }

    case (actionTypes.GET_USER_SUBSCRIPTIONS): {
      return Object.assign({}, state, {
        isLoading: true,
        isFinished: false,
        isError: false,
        error: null,
      });
    }

    case (actionTypes.GET_USER_SUBSCRIPTIONS_SUCCESS): {
      let newState = Object.assign({}, state, {
        isLoading: false,
        isFinished: true,
      });

      return update(newState, {
        data: {
          subscriptions: {
            $merge: groupBy(action.payload, "subscription_type"),
          },
        },
      });
    }

    case (actionTypes.CHANGE_USER_SUBSCRIPTIONS): {
      return update(state, {
        data: {
          profileInfo: {
            $merge: {
              subscriptionIds: action.payload,
            },
          },
        },
      });
    }

    case (actionTypes.SUBMIT_USER_SAVED_STORIES_SUCCESS): {
      return update(state, {
        data: {
          profileInfo: {
            $merge: {
              savedStoryIds: action.payload,
            },
          },
        },
      });
    }

    case (actionTypes.LOG_OUT):  {
      return {
        ...state,
        data: {
          profileInfo: {
            first_name: "",
            last_name: "",
            email: "",
            job_title: "",
            industry: "",
            subscriptionIds: [],
            savedStoryIds: [],
            saved_stories: [],
            linkedin: "",
            facebook: "",
            twitter: "",
          },
          subscriptions: [],
        },
      };
    }

    default: {
      return state;
    }
  }
};



// WEBPACK FOOTER //
// ./src/users/reducers/userSettings.js